export function required(value) {
    return ![null,"",[], false].includes(value);
}

export default function(bookingStore, item, path, value)
{
    if (item.required) {
        if (!required(value)) {
            bookingStore.addError(path, 'validation.required', item);
        }
    }
}

